import React from 'react'
import classes from './Details.module.sass'
import {  StoreInterface } from '../../../../../common/types/interfaces'
import { useSelector } from 'react-redux'
import { selectClusterImageUrl } from '../../../../../store/slices/currentClusterSlice'

type Props = {
  el?: StoreInterface
}

export const Details = ({ el }: Props) => {
 const imageUrl = useSelector(selectClusterImageUrl)


  if (el)
    return (
      <div className={classes.container}>
        <div className={classes.name}>{el.name}</div>
        <div className={classes.dscription}>{el.description}</div>

        <div className={classes.images}>
          {el.files.map((path) => (
            <img className={classes.image} src={`${imageUrl}${[path]}`} alt={el.name} />
          ))}
        </div>
      </div>
    )
}
